import React, { useEffect, useState } from "react"
import { InputNumber, Button, message, Spin, Form, Table } from "antd"
import { SaveOutlined } from "@ant-design/icons"
import { WrapperStyle } from "src/pages/ADMIN/HumanResource/styled"
import { ToolBarStyle } from "src/pages/ADMIN/Finance/Internal/styled"
import OrderB2BService from "src/services/OrderB2BService"
import PackageHistoryModal from "./components/PackageHistoryModal"
import EditPriceModal from "./components/EditPriceModal"

const PackagePricing = () => {
  const [form] = Form.useForm()
  const [loading, setLoading] = useState(false)
  const [saving, setSaving] = useState(false)
  const [packages, setPackages] = useState([])
  const [openHistory, setOpenHistory] = useState(false)
  const [selectedPackageId, setSelectedPackageId] = useState(null)
  const [openEdit, setOpenEdit] = useState(false)
  const [selectedPackage, setSelectedPackage] = useState(null)

  // Gọi API lấy danh sách gói cước
  const fetchPackages = async () => {
    try {
      setLoading(true)
      const res = await OrderB2BService.getPackagePrice({ mode: "0" })
      if (res.success.data && Array.isArray(res.success.data)) {
        const data = res.success.data.map(pkg => {
          // const priceIn = Number(
          //   pkg?.setting_package_parent?.price || pkg.price_sell || 0,
          // )
          // const priceSell = Number(
          //   pkg.setting_package?.price || pkg.price_sell || 0,
          // )

          return {
            ...pkg,
            package_code: pkg.package?.package_code || "",
            name: pkg.package?.name || "",
            price_in: Number(pkg.parent_price) || Number(pkg.base_price) || 0,
            // price_sell: priceSell,
            // profit: priceSell - priceIn, // ✅ thêm lợi nhuận
          }
        })
        setPackages(data)
      } else {
        message.warning("Không có dữ liệu gói cước")
      }
    } catch (err) {
      console.error(err)
      message.error("Lỗi khi tải danh sách gói cước")
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchPackages()
  }, [])

  // Lưu giá bán
  // const handleSave = async () => {
  //   try {
  //     setSaving(true)
  //     const payload = packages.map(pkg => ({
  //       package_id: pkg.ID,
  //       price: Number(pkg.price_sell),
  //     }))
  //     const res = await OrderB2BService.createPackagePrice({
  //       list_package: payload,
  //     })
  //     if (res.message.includes("thành công")) {
  //       message.success(res.message || "Lưu giá bán thành công")
  //       fetchPackages() // Tải lại dữ liệu sau khi lưu
  //     } else {
  //       message.error(res.message || "Lưu thất bại")
  //     }
  //   } catch (err) {
  //     console.error(err)
  //     message.error("Có lỗi khi lưu giá bán")
  //   } finally {
  //     setSaving(false)
  //   }
  // }

  const columns = [
    { title: "ID", dataIndex: "ID", key: "ID", hidden: true },
    { title: "Mã gói", dataIndex: "package_code", key: "package_code" },
    { title: "Tên gói", dataIndex: "name", key: "name" },
    {
      title: "Giá nhập (VNĐ)",
      dataIndex: "price_in",
      key: "price_in",
      render: value => value?.toLocaleString("en-US"),
    },
    // {
    //   title: "Giá bán (VNĐ)",
    //   dataIndex: "price_sell",
    //   key: "price_sell",
    //   render: (text, record) => (
    //     <InputNumber
    //       min={0}
    //       value={text}
    //       formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
    //       parser={value => value.replace(/[^0-9]/g, "")}
    //       onClick={e => e.stopPropagation()}
    //       onChange={value => {
    //         const newPackages = [...packages]
    //         const index = newPackages.findIndex(pkg => pkg.ID === record.ID)
    //         newPackages[index].price_sell = value
    //         // ✅ tính lại lợi nhuận khi thay đổi giá bán
    //         newPackages[index].profit = value - newPackages[index].price_in
    //         setPackages(newPackages)
    //       }}
    //     />
    //   ),
    // },
    // {
    //   title: "Lợi nhuận dự kiến (VNĐ)",
    //   dataIndex: "profit",
    //   key: "profit",
    //   render: value => (
    //     <span
    //       style={{ fontWeight: "bold", color: value >= 0 ? "green" : "red" }}
    //     >
    //       {value?.toLocaleString("en-US")}
    //     </span>
    //   ),
    // },
  ]

  return (
    <WrapperStyle>
      <ToolBarStyle>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginTop: 4,
            marginBottom: 20,
          }}
        >
          <h3
            style={{
              fontSize: "24px",
              fontWeight: "bold",
              color: "#005F90",
              margin: 0,
            }}
          >
            CÀI ĐẶT GIÁ BÁN 
          </h3>
        </div>
      </ToolBarStyle>
      <Table
        dataSource={packages}
        columns={columns}
        rowKey="ID"
        pagination={false}
        loading={loading}
        onRow={record => ({
          onClick: () => {
            setSelectedPackage(record)
            setOpenEdit(true)
          },
        })}
      />
      {/* <div style={{ textAlign: "right", marginTop: 16 }}>
        <Button
          type="primary"
          icon={<SaveOutlined />}
          onClick={handleSave}
          loading={saving}
        >
          Lưu giá bán
        </Button>
      </div> */}
      {/* {openHistory && (
        <PackageHistoryModal
          open={openHistory}
          onClose={() => setOpenHistory(false)}
          packageId={selectedPackageId}
        />
      )} */}
      {openEdit && (
        <EditPriceModal
          open={openEdit}
          pkg={selectedPackage}
          onClose={() => setOpenEdit(false)}
          onSuccess={fetchPackages} // reload lại danh sách sau khi lưu
        />
      )}
    </WrapperStyle>
  )
}

export default PackagePricing
